import { render, staticRenderFns } from "./EmiSchemeItem.vue?vue&type=template&id=64bad458&scoped=true&"
import script from "./EmiSchemeItem.vue?vue&type=script&lang=js&"
export * from "./EmiSchemeItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=64bad458&scoped=true&lang=css&"
import style1 from "./EmiSchemeItem.vue?vue&type=style&index=1&id=64bad458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bad458",
  null
  
)

export default component.exports